export const AWS_REGION = 'us-east-1';

export const DUMMY_IMAGE =
  'https://aloompa-assets.imgix.net/citizen/701d17da-7a29-498a-aaf1-10caa7f7f2dc/a757a44a-7f7c-421c-a482-05cc2516d66b.png?w=375&h=219&fit=fill&fill-color=ecedf1';
